import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { LabelCheckValue } from '@ulysses-inc/harami_api_client'
import { useContext } from 'react'
import { LabelCheckAnswerStoreContext } from 'src/features/labelCheck/contexts/LabelCheckAnswerStoreContext'
import Grid from 'src/features/reports/result/downloadPDF/Grid'
import { Header } from './Header'
import { LabelItem } from './LabelItem'

const styles = StyleSheet.create({
  grid: { width: '100%' },
  notAnswered: {
    padding: 5,
  },
})

type Props = {
  questionName: string
  labelCheckValue?: LabelCheckValue
}

/**
 * このコンポーネントは @see {LabelCheckAnswerPDFProvider} の中で使用される必要があります。
 */
export const LabelCheckAnswerForPDF = ({
  questionName,
  labelCheckValue,
}: Props) => {
  const labelInspectionResultId = labelCheckValue?.reportLabelInspectionId

  const { labelInspectionResultMap } = useContext(LabelCheckAnswerStoreContext)
  const labelInspectionResult = labelInspectionResultId
    ? labelInspectionResultMap.get(labelInspectionResultId)
    : undefined

  return (
    <Grid borderLeft borderRight style={styles.grid}>
      <View style={{ width: '100%' }}>
        <Header
          questionName={questionName}
          labelInspectionResultName={labelInspectionResult?.name}
        />

        {!labelInspectionResult ? (
          <Text style={styles.notAnswered}>未回答</Text>
        ) : (
          <View style={{ width: '100%' }}>
            {labelInspectionResult.reportLabels.map(labelResult => (
              <LabelItem key={labelResult.labelId} labelResult={labelResult} />
            ))}
          </View>
        )}
      </View>
    </Grid>
  )
}
